import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

/**
 * 空状态组件
 */
const FavoritesEmpty = () => {
  const navigate = useNavigate();

  const content = {
    title: 'No favorites yet',
    buttonText: 'Start Exploring',
  };

  return (
    <div className='text-center py-12'>
      {/* 标题 */}
      <h3 className='text-lg font-semibold text-gray-800 mb-6'>
        {content.title}
      </h3>

      {/* 操作按钮 */}
      <Link
        to='/'
        className='inline-block px-6 py-3 border-2 border-black text-black rounded-lg hover:bg-tag-blue hover:text-white transition-colors duration-200'
      >
        {content.buttonText}
      </Link>
    </div>
  );
};

export default FavoritesEmpty;
